import { defineStore } from 'pinia';
import { ref } from 'vue';
import { customersApi, type CustomerProfile } from '@/services/api';

/**
 * Logged-in customer's profile. Kept in memory only (it is personal data):
 * reloaded from GET customers/me on every app start with a valid session.
 */
export const useCustomerStore = defineStore('customer', () => {
  const profile = ref<CustomerProfile | null>(null);

  async function load(): Promise<CustomerProfile> {
    profile.value = await customersApi.me();
    return profile.value;
  }

  function clear(): void {
    profile.value = null;
  }

  return { profile, load, clear };
});
